import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './Flag.scss'

const Flag = ({ code }) => (
    <div className={cx(styles.base, styles[`base__${code}`])} />
)

Flag.propTypes = {
    code: PropTypes.string.isRequired,
}

export default Flag


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Flag/Flag.jsx